import React, { useState } from 'react';
import { errorMessage } from '../api';
import { useAuth } from '../context/AuthContext';
import AuthLayout from './AuthLayout';

export default function Register({ onSwitch }) {
  const { register } = useAuth();
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setBusy(true);
    try {
      await register(username.trim(), email.trim(), password);
    } catch (err) {
      // Servern säger vad som är fel (upptaget namn, för kort lösenord...).
      setError(errorMessage(err, 'Kontot kunde inte skapas.'));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthLayout title="Skapa konto">
      <form className="auth-form" onSubmit={handleSubmit}>
        {error && <p className="notice notice--error">{error}</p>}
        <input
          placeholder="Användarnamn"
          value={username}
          onChange={e => setUsername(e.target.value)}
          required
          minLength={3}
          maxLength={30}
          autoComplete="username"
        />
        <input
          type="email"
          placeholder="E-post"
          value={email}
          onChange={e => setEmail(e.target.value)}
          required
          autoComplete="email"
        />
        <input
          type="password"
          placeholder="Lösenord"
          value={password}
          onChange={e => setPassword(e.target.value)}
          required
          minLength={8}
          autoComplete="new-password"
        />
        <p className="auth-form__hint">Lösenordet måste vara minst 8 tecken.</p>
        <button className="btn btn--primary" type="submit" disabled={busy}>
          {busy ? 'Skapar konto...' : 'Skapa konto'}
        </button>
        <button className="btn btn--outline" type="button" onClick={onSwitch}>
          Har redan konto
        </button>
      </form>
    </AuthLayout>
  );
}
